import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { ActionScope } from '../../../../shared/action/ActionModel';
import { StringActionDetail } from './components/StringActionDetail';
import { ScopeSelectionActionDetail } from './components/ScopeSelectionActionDetail';
import { Dropdown } from "../../editor/Dropdown";
import { isBlank } from "../../../../shared/helper/generalHelpers";
import { sharedStore } from '../../../stores/SharedStore';
import { getTreeParent } from '../../../../shared/action/ActionTreeModel';
import { editorStore } from '../../../stores/EditorStore';
import { ElementGroup, ElementLabel } from './components/BaseElements';
const ActionParameterSelectVariable = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  const tree = action.scope === ActionScope.Tree ? getTreeParent(action) : sharedStore.mainGameRootActionTree;
  const variablesInTree = [...tree.variableNames(action.scope)];
  return /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, t("action_editor.property_variable_existing")), /*#__PURE__*/React.createElement(Dropdown, {
    className: isBlank(action.name) ? "invalid" : "",
    value: action.name,
    onChange: ({
      target
    }) => action.setName(target.value)
  }, variablesInTree.map(variableName => /*#__PURE__*/React.createElement("option", {
    key: variableName,
    value: variableName
  }, variableName))));
});
export const SetVariableActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, editorStore.isMainGameEditor && /*#__PURE__*/React.createElement(ScopeSelectionActionDetail, {
    scope: action.scope,
    scopeSetter: action.setScope.bind(action)
  }), /*#__PURE__*/React.createElement(StringActionDetail, {
    name: t("action_editor.new_variable"),
    value: action.name,
    valueSetter: action.setName.bind(action),
    allowBlankValue: false
  }), /*#__PURE__*/React.createElement(ActionParameterSelectVariable, {
    action: action
  }), /*#__PURE__*/React.createElement(StringActionDetail, {
    name: t("action_editor.property_value"),
    value: action.value,
    valueSetter: action.setValue.bind(action),
    allowBlankValue: false
  }));
});